<template>
  <div>
    <AppHeader />

    <section class="legal-hero">
      <div class="container">
        <h1>Политика конфиденциальности</h1>
        <p class="legal-updated">Редакция от {{ updated }}</p>
      </div>
    </section>

    <section class="legal-content">
      <div class="container legal-container">
        <p class="legal-lead">
          Настоящая Политика конфиденциальности (далее — «Политика») действует в отношении
          информации, которую Индивидуальный предприниматель Мищенко Алина Сергеевна
          (далее — «Оператор») может получить о пользователе во время использования им сайта
          «Мама, я в Китае».
        </p>

        <ol>
          <li>
            <h2>Общие положения</h2>
            <ol>
              <li>Использование сайта означает безоговорочное согласие пользователя с настоящей Политикой и указанными в ней условиями обработки его персональной информации.</li>
              <li>В случае несогласия с условиями пользователь должен воздержаться от использования сайта.</li>
              <li>Политика применяется только к сайту Оператора и не распространяется на сторонние сайты, ссылки на которые могут быть размещены на сайте.</li>
            </ol>
          </li>

          <li>
            <h2>Состав персональных данных</h2>
            <ol>
              <li>Персональные данные — любая информация, относящаяся к прямо или косвенно определённому физическому лицу (субъекту персональных данных).</li>
              <li>Оператор обрабатывает следующие персональные данные:
                <ul>
                  <li>фамилия, имя;</li>
                  <li>адрес электронной почты;</li>
                  <li>контактные данные, указанные пользователем добровольно (телефон, аккаунты в мессенджерах/соцсетях);</li>
                  <li>файлы cookie, IP-адрес и иные технические данные, собираемые автоматически.</li>
                </ul>
              </li>
            </ol>
          </li>

          <li>
            <h2>Цели обработки персональных данных</h2>
            <ol>
              <li>Создание учётной записи и идентификация пользователя в личном кабинете.</li>
              <li>Оказание образовательных услуг (проведение занятий, доступ к материалам курсов).</li>
              <li>Связь с пользователем, в том числе уведомления, рассылки и ответы на обращения.</li>
              <li>Оформление и сопровождение заявок, оплат и документов.</li>
              <li>Улучшение работы сайта, сбор статистики и аналитика посещаемости.</li>
            </ol>
          </li>

          <li>
            <h2>Правовое основание обработки</h2>
            <p>Обработка персональных данных осуществляется на основании:</p>
            <ul>
              <li>согласия пользователя (ст. 6 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных»);</li>
              <li>исполнения договора, стороной которого является пользователь;</li>
              <li>требований законодательства Российской Федерации.</li>
            </ul>
          </li>

          <li>
            <h2>Условия обработки и передачи данных</h2>
            <ol>
              <li>Оператор не передаёт персональные данные третьим лицам, за исключением случаев, прямо предусмотренных законом или когда пользователь дал на это согласие.</li>
              <li>Оператор вправе поручить обработку данных подрядчикам (хостинг, платёжные сервисы, сервисы аналитики), обязав их соблюдать конфиденциальность.</li>
              <li>При сборе статистики и аналитике могут использоваться файлы cookie и технологии сторонних сервисов (например, сервисы Яндекс).</li>
            </ol>
          </li>

          <li>
            <h2>Файлы cookie</h2>
            <p>
              Сайт использует файлы cookie для корректной работы, запоминания настроек и сбора
              статистики. Пользователь может отключить cookie в настройках браузера, однако это
              может повлиять на работу некоторых функций сайта. Подробнее — в разделе
              <router-link to="/terms">Пользовательское соглашение</router-link>.
            </p>
          </li>

          <li>
            <h2>Права пользователя</h2>
            <p>Пользователь имеет право:</p>
            <ul>
              <li>получать информацию об обработке своих персональных данных;</li>
              <li>требовать уточнения, блокирования или уничтожения своих персональных данных;</li>
              <li>отозвать согласие на обработку, направив обращение Оператору.</li>
            </ul>
          </li>

          <li>
            <h2>Меры защиты</h2>
            <p>
              Оператор принимает необходимые организационные и технические меры для защиты
              персональных данных от неправомерного доступа, изменения, раскрытия или уничтожения.
            </p>
          </li>

          <li>
            <h2>Изменение Политики</h2>
            <p>
              Оператор имеет право вносить изменения в настоящую Политику. Актуальная версия
              размещается на данной странице.
            </p>
          </li>

          <li>
            <h2>Контактная информация</h2>
            <p>По вопросам обработки персональных данных обращаться к Оператору:</p>
            <ul>
              <li>ИП Мищенко Алина Сергеевна</li>
              <li>ИНН 545328832110</li>
              <li>ОГРНИП 323547600086166</li>
              <li>через форму на странице <router-link to="/contacts">Контакты</router-link>.</li>
            </ul>
          </li>
        </ol>
      </div>
    </section>

    <UIFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import UIFooter from '@/components/ui/UIFooter.vue'

export default {
  name: 'PrivacyPage',
  components: { AppHeader, UIFooter },
  data() {
    return { updated: '01.07.2026' }
  }
}
</script>

<style scoped>
.legal-hero {
  background: radial-gradient(circle at top, rgba(231, 76, 60, 0.12), transparent 60%), #f5f1ef;
  padding: 120px 0 40px;
  text-align: center;
}
.legal-hero h1 {
  font-size: 2.2rem;
  font-weight: 800;
  color: #2c3e50;
  margin-bottom: 8px;
}
.legal-updated { color: #6c757d; font-size: 0.95rem; }
.legal-content { padding: 48px 0 72px; background: #fff; }
.legal-container { max-width: 820px; }
.legal-lead { font-size: 1.05rem; color: #495057; margin-bottom: 1.5rem; }
.legal-content h2 { font-size: 1.25rem; font-weight: 700; color: #2c3e50; margin: 0 0 0.5rem; }
.legal-container > ol { counter-reset: legal; padding-left: 0; list-style: none; }
.legal-container > ol > li { position: relative; padding-left: 40px; margin-bottom: 1.75rem; }
.legal-container > ol > li::before {
  counter-increment: legal;
  content: counter(legal);
  position: absolute;
  left: 0;
  top: 0;
  width: 28px; height: 28px; line-height: 28px; text-align: center;
  background: linear-gradient(135deg, #e74c3c, #c0392b);
  color: #fff; border-radius: 50%;
  font-size: 0.85rem; font-weight: 700;
}
.legal-content ol ol { padding-left: 1.5rem; margin-top: 0.5rem; list-style: decimal; }
.legal-content ol ol > li { position: static; padding-left: 0; margin-bottom: 0.5rem; }
.legal-content ol ol > li::before { display: none; }
.legal-content ul { margin: 0.5rem 0 0.5rem 1.25rem; }
.legal-content li { color: #495057; line-height: 1.7; }
.legal-content a { color: #e74c3c; text-decoration: none; }
.legal-content a:hover { text-decoration: underline; }
</style>
